import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import report from "./reports";
import reportSummary from "./reports/summary";
import _ from "lodash"

export default class Falhas extends Indicador {
    static get fullName() {
        return "Registro de Falhas";
    }

    static get abbrev() {
        return "Falhas";
    }

    static get multTipo() {
        return true
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static get legacyApontamentoMap() {
        const putPontoColetado = (index, field, ajustValues) => (value, atualNewValue) => {
            if ('images' === field) {

            }
            let arrayPontos = atualNewValue ? atualNewValue : []
            let valueUse = ajustValues ? ajustValues(value) : value

            if (arrayPontos.length > index)
                if (valueUse) {
                    arrayPontos[index][field] = valueUse
                }
            return arrayPontos
        }
        const convertPonto = (value, atualNewValue) => {
            let arrayPontos = atualNewValue ? atualNewValue : []
            if (value) {
                arrayPontos.push({ coletas: value })
            }
            return arrayPontos
        }
        const ajustImages = (value) => {
            if (value) {

                let newArray = [...value]
                newArray.forEach(f => {

                    let img = f.imagem;
                    if (img) {

                        delete f.imagem
                        let tp = 'jpeg'
                        f.base64 = "data:image/" + tp + ";base64," + img.base64
                    }
                });
                return newArray;

            }

            return value;
        }


        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },
            tipo: "tipo",
            talhao: "talhao",
            turno: "turno",

            coletasPonto1: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto2: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto3: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto4: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto5: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto6: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto7: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto8: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto9: { newField: "pontosColetas", convert: convertPonto, },
            coletasPonto10: { newField: "pontosColetas", convert: convertPonto, },

            georeferenciaPonto1: { newField: "pontosColetas", convert: putPontoColetado(0, 'georeferencia'), },
            georeferenciaPonto2: { newField: "pontosColetas", convert: putPontoColetado(1, 'georeferencia'), },
            georeferenciaPonto3: { newField: "pontosColetas", convert: putPontoColetado(2, 'georeferencia'), },
            georeferenciaPonto4: { newField: "pontosColetas", convert: putPontoColetado(3, 'georeferencia'), },
            georeferenciaPonto5: { newField: "pontosColetas", convert: putPontoColetado(4, 'georeferencia'), },
            georeferenciaPonto6: { newField: "pontosColetas", convert: putPontoColetado(5, 'georeferencia'), },
            georeferenciaPonto7: { newField: "pontosColetas", convert: putPontoColetado(6, 'georeferencia'), },
            georeferenciaPonto8: { newField: "pontosColetas", convert: putPontoColetado(7, 'georeferencia'), },
            georeferenciaPonto9: { newField: "pontosColetas", convert: putPontoColetado(8, 'georeferencia'), },
            georeferenciaPonto10: { newField: "pontosColetas", convert: putPontoColetado(9, 'georeferencia'), },

            totalPonto1: { newField: "pontosColetas", convert: putPontoColetado(0, 'conformidade'), },
            totalPonto2: { newField: "pontosColetas", convert: putPontoColetado(1, 'conformidade'), },
            totalPonto3: { newField: "pontosColetas", convert: putPontoColetado(2, 'conformidade'), },
            totalPonto4: { newField: "pontosColetas", convert: putPontoColetado(3, 'conformidade'), },
            totalPonto5: { newField: "pontosColetas", convert: putPontoColetado(4, 'conformidade'), },
            totalPonto6: { newField: "pontosColetas", convert: putPontoColetado(5, 'conformidade'), },
            totalPonto7: { newField: "pontosColetas", convert: putPontoColetado(6, 'conformidade'), },
            totalPonto8: { newField: "pontosColetas", convert: putPontoColetado(7, 'conformidade'), },
            totalPonto9: { newField: "pontosColetas", convert: putPontoColetado(8, 'conformidade'), },
            totalPonto10: { newField: "pontosColetas", convert: putPontoColetado(9, 'conformidade'), },


            imagensPonto1: { newField: "pontosColetas", convert: putPontoColetado(0, 'images', ajustImages), },
            imagensPonto2: { newField: "pontosColetas", convert: putPontoColetado(1, 'images', ajustImages), },
            imagensPonto3: { newField: "pontosColetas", convert: putPontoColetado(2, 'images', ajustImages), },
            imagensPonto4: { newField: "pontosColetas", convert: putPontoColetado(3, 'images', ajustImages), },
            imagensPonto5: { newField: "pontosColetas", convert: putPontoColetado(4, 'images', ajustImages), },
            imagensPonto6: { newField: "pontosColetas", convert: putPontoColetado(5, 'images', ajustImages), },
            imagensPonto7: { newField: "pontosColetas", convert: putPontoColetado(6, 'images', ajustImages), },
            imagensPonto8: { newField: "pontosColetas", convert: putPontoColetado(7, 'images', ajustImages), },
            imagensPonto9: { newField: "pontosColetas", convert: putPontoColetado(8, 'images', ajustImages), },
            imagensPonto10: { newField: "pontosColetas", convert: putPontoColetado(9, 'images', ajustImages), },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }


    static get legacyParamMap() {
        return {
            metaFalhasManual: "manual.meta",
            metrosPorPontoManual: "manual.metrosPorPonto",

            metaFalhasMecanizado: "mecanizado.meta",
            metrosPorPontoMecanizado: "mecanizado.metrosPorPonto",


        };
    }
    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    static async validFieldErrors(values, pathStr) {

        let ptsColetas = _.get(values, pathStr).pontosColetas

        if (ptsColetas) {
            for (let i = 0; i < ptsColetas.length; i++) {
                let clts = ptsColetas[i].coletas
                if (clts) {
                    for (let j = 0; j < clts.length; j++) {
                        if (!clts[j].valor) {
                            return ["Coleta sem preencher"]
                        }
                    }
                } else {
                    return ["Não há coleta"]
                }
            }
        } else {
            return ["Não há ponto de coletas"]
        }

        return null
    }

    async renderReport(visita) {
        return report(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return reportSummary(this, visita, tipoName);
    }

    getAverage(visita, field, tipoName, params) {
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName)

        if (apontamentos.length) {
            if (field === "conformidade") {
                let somaValor = 0, somaArea = 0, ponderacao = 0

                apontamentos.forEach(p => {
                    let valor = p.talhao.area && p.conformidade ? parseFloat(p.talhao.area) * parseFloat(p.conformidade) : 0;
                    valor = valor.toFixed(3)
                    somaValor += parseFloat(valor)
                    somaArea += p.talhao ? parseFloat(p.talhao.area) : 0
                })

                if (somaArea && somaArea !== 0) {
                    ponderacao = parseFloat(somaValor) / parseFloat(somaArea)
                }

                ponderacao = parseFloat(ponderacao)

                return parseFloat(ponderacao)
            }
        }
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;
        let pontosAux = Array.from(apontamento.pontosColetas || [])

        pontosAux = pontosAux.filter(p => (p.coletas?.filter(c => c.valor) || []).length)

        if (!pontosAux || !params || pontosAux.length === 0) {
            return 0;
        }
        let metrosPorPonto = params.metrosPorPonto * 100
        let conformidade = 0
        let qtPontos = 0
        let totalFalhas = 0

        qtPontos = pontosAux.length

        let totalFalhasPonto = 0
        pontosAux.forEach(ponto => {
            totalFalhasPonto = 0
            if (ponto.coletas && ponto.coletas.length) {
                ponto.coletas.forEach(coleta => {
                    if (!isNaN(coleta.valor)) {
                        totalFalhasPonto += f(coleta.valor)
                        totalFalhas += f(coleta.valor)
                    }
                })
            }
            if (totalFalhasPonto) {
                ponto.conformidade = (totalFalhasPonto / metrosPorPonto * 100).toFixed(2)
            }
        });

        conformidade = totalFalhas / (qtPontos * metrosPorPonto) * 100

        apontamento.acima = conformidade > f(params.meta) ? 1 : 0
        apontamento.abaixo = 0

        return conformidade.toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        if (parseFloat(conformidade) < parseFloat(meta)) {
            return "Ótimo"
        } else {
            return "Ruim"
        }
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {

        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },

            {
                title: "Conformidade (%) ", field: "conformidade", width: 'auto', getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        let strAux = ""
        let pontosAux = Array.from(apontamento.pontosColetas)
        pontosAux = pontosAux.map(p => {
            let coletas = p.coletas?.filter(c => c.valor) || []

            p.coletas = coletas

            return p
        })

        for (let i = 0; i < pontosAux.length; i++) {
            if (i > 0) {
                if (i + 1 === pontosAux.length) {
                    strAux = strAux + "; e "
                } else {
                    strAux = strAux + "; "
                }
            }

            strAux = strAux + "Ponto " + (i + 1) + ": ("

            for (let j = 0; j < pontosAux[i].coletas?.length; j++) {
                if (j > 0) {
                    if (j + 1 === pontosAux[i].coletas.length) {
                        strAux = strAux + " e "
                    } else {
                        strAux = strAux + ", "
                    }
                }
                strAux = strAux + pontosAux[i].coletas[j].valor
            }

            strAux = strAux + ")"

            if (i + 1 === pontosAux.length) {
                strAux = strAux + "."
            }
        }

        return strAux
    }
}


